import uPlot from "uplot";
import { PatientVisit } from "../../amplify/api-gateway/search-patients";

export const tooltipsNumericsPlugin = (setCursPos: any, relatedPatientVisits: any, navigateToPatientVisit: any) => {
    let seriestt: any;

    function init(u: any, opts: any, data: any) {
        let over = u.over;

        seriestt = opts.series.map((s: any, i: any) => {
            let tt = document.createElement("div");
            tt.className = "visit-selector-tooltip";
            tt.textContent = "";
            over.appendChild(tt);
            return tt;
        });

        function hideTips() {
            seriestt.forEach((tt: any, i: any) => {
                tt.style.display = "none";
                tt.style.opacity = 0;
            });
        }

        function showTips() {
            seriestt.forEach((tt: any, i: any) => {
                let s = u.series[i];
                tt.style.display = s.show ? null : "none";
                tt.style.opacity = 100;
            });
        }

        over.addEventListener("mouseleave", () => {
            if (!u.cursor._lock) {
                hideTips();
            }
        });

        over.addEventListener("mouseenter", () => {
            showTips();
        });

        if (u.cursor.left < 0)
            hideTips();
        else
            showTips();

        u.over.onclick = (e: any) => {
            let clickedTimestamp = u.posToVal(e.offsetX, 'x');

            // Find closest patient visit to click
            let closest: PatientVisit | null = null;
            let currDiff = Math.max();
            for (let pt of relatedPatientVisits) {
                const diff = (Math.abs(clickedTimestamp * 1000 - new Date(pt.arrival_time).getTime()));
                if (!closest) {
                    closest = pt;
                    currDiff = diff;
                } else {
                    if (diff < currDiff) {
                        closest = pt;
                        currDiff = diff;
                    }
                }
            }
            if (closest) {
                navigateToPatientVisit(closest);          
            }      
        }
    }

    function setCursor(u: any) {
        const {left, top, idx} = u.cursor;

        setCursPos({
            left: left,
            top: top,
        })

        let yRanges: any = []; // To avoid overlapping tooltips
        seriestt.forEach((tt: any, i: any) => {
            if (i == 0) {
                // Date indicator at the top
                try {
                    let xVal = new Date(u.data[0][idx] * 1000).toLocaleDateString();
                    tt.textContent = xVal;
                } catch {
                    tt.textContent = "";
                }
                tt.style.left = Math.round(u.valToPos(u.data[0][idx], 'x')) + "px";
                tt.style.top = "0px";
            } else {
                // Mouse over for each series
                let s = u.series[i];
                let spacing = 15;

                if (s.show && u.data && u.data[i]) {
                    if (u.data[i][idx] && s.label !== "NBPd") {
                        let xVal = u.data[0][idx];
                        let yVal = u.data[i][idx];
                        let textVal = `${s.label} ${yVal}`;
    
                        if (s.label === "NBPs") {
                            textVal = `BP ${yVal}/${u.data[5][idx]}`;
                        }
                        tt.textContent = textVal

                        let yPixelVal = Math.round(u.valToPos(yVal, s.scale));
                        let adjustedYPixelVal = yPixelVal;
                        let hasOverlap = true;
                        while (hasOverlap) {
                            let foundOverlap = false;
                            for (let range of yRanges) {
                                if ((adjustedYPixelVal >= range[0] && adjustedYPixelVal < range[1]) || ((adjustedYPixelVal + spacing) >= range[0] && (adjustedYPixelVal + spacing) < range[1])) {
                                    // Overlap found so try to move current tooltip down a bit
                                    adjustedYPixelVal = adjustedYPixelVal + spacing;
                                    foundOverlap = true;
                                    break;
                                }
                            }
                            if (foundOverlap) {
                                continue;
                            }
                            hasOverlap = false;
                        }
                        yRanges.push([adjustedYPixelVal, adjustedYPixelVal + spacing]);

                        tt.style.left = Math.round(u.valToPos(xVal, 'x')) + "px";
                        tt.style.top = adjustedYPixelVal + "px";
                        tt.className = `visit-selector-tooltip visit-selector-tooltip-${s.label}`
                    } else {
                        // There was no data for this particular date so move it out of view
                        tt.style.left = "-1000px";
                        tt.style.top = "-1000px";
                    }
                }
            }
        });
    }

    return {
        hooks: {
            init,
            setCursor,
        },
    };
}


export const tooltipsSummaryPlugin = (setCursPos: any, relatedPatientVisits: any, navigateToPatientVisit: any) => {
    let seriestt: any;

    function init(u: any, opts: any, data: any) {
        let over = u.over;

        seriestt = opts.series.map((s: any, i: any) => {
            let tt = document.createElement("div");
            tt.className = "visit-selector-tooltip";
            tt.textContent = "";
            over.appendChild(tt);
            return tt;
        });

        function hideTips() {
            seriestt.forEach((tt: any, i: any) => {
                tt.style.display = "none";
                tt.style.opacity = 0;
            });
        }

        function showTips() {
            seriestt.forEach((tt: any, i: any) => {
                let s = u.series[i];
                tt.style.display = s.show ? null : "none";
                tt.style.opacity = 100;
            });
        }

        over.addEventListener("mouseleave", () => {
            if (!u.cursor._lock) {
                hideTips();
            }
        });

        over.addEventListener("mouseenter", () => {
            showTips();
        });

        if (u.cursor.left < 0)
            hideTips();
        else
            showTips();

        u.over.onclick = (e: any) => {
            console.log(u.select);
            let clickedTimestamp = u.posToVal(e.offsetX, 'x');

            // Find closest patient visit to click
            let closest: PatientVisit | null = null;
            let currDiff = Math.max();
            for (let pt of relatedPatientVisits) {
                const diff = (Math.abs(clickedTimestamp * 1000 - new Date(pt.arrival_time).getTime()));
                if (!closest) {
                    closest = pt;
                    currDiff = diff;
                } else {
                    if (diff < currDiff) {
                        closest = pt;
                        currDiff = diff;
                    }
                }
            }
            if (closest) {
                navigateToPatientVisit(closest);          
            }      
        }
    }

    function setCursor(u: any) {
        const {left, top, idx} = u.cursor;

        setCursPos({
            left: left,
            top: top,
        })

        let yRanges: any = []; // To avoid overlapping tooltips
        seriestt.forEach((tt: any, i: any) => {
            if (i == 0) {
                // Date indicator at the top
                let xVal = new Date(u.data[0][idx] * 1000).toLocaleDateString();
                tt.textContent = xVal;
                tt.style.left = Math.round(u.valToPos(u.data[0][idx], 'x')) + "px";
                tt.style.top = "-16px";
            } else {
                // Mouse over for each series
                let s = u.series[i];
                let spacing = 15;

                if (s.show && u.data && u.data[i]) {
                    if (u.data[i][idx]) {
                        let xVal = u.data[0][idx];
                        let yVal = u.data[i][idx];
                        let textVal = `${s.label}`;
                        tt.textContent = textVal

                        let yPixelVal = Math.round(u.valToPos(yVal, s.scale));
                        let adjustedYPixelVal = yPixelVal;
                        let hasOverlap = true;
                        while (hasOverlap) {
                            let foundOverlap = false;
                            for (let range of yRanges) {
                                if ((adjustedYPixelVal >= range[0] && adjustedYPixelVal < range[1]) || ((adjustedYPixelVal + spacing) >= range[0] && (adjustedYPixelVal + spacing) < range[1])) {
                                    // Overlap found so try to move current tooltip down a bit
                                    adjustedYPixelVal = adjustedYPixelVal + spacing;
                                    foundOverlap = true;
                                    break;
                                }
                            }
                            if (foundOverlap) {
                                continue;
                            }
                            hasOverlap = false;
                        }
                        yRanges.push([adjustedYPixelVal, adjustedYPixelVal + spacing]);

                        tt.style.left = Math.round(u.valToPos(xVal, 'x')) + "px";
                        tt.style.top = adjustedYPixelVal + "px";
                        tt.className = `visit-selector-tooltip visit-selector-tooltip-${s.label}`
                    } else {
                        // There was no data for this particular date so move it out of view
                        tt.style.left = "-1000px";
                        tt.style.top = "-1000px";
                    }
                }
            }
        });
    }

    return {
        hooks: {
            init,
            setCursor,
        },
    };
}

/**
 * The uPlot plugin to draw the points as a series of points
 * @param baseRadius The radius of the points
 * @returns The uPlot plugin
 */
export function pointsPlugin({ baseRadius = 4 } = {}) {
    function drawCircle(ctx: any, cx: number, cy: number, color: string) {
        ctx.beginPath();
        ctx.fillStyle = color + "AA"; // with opacity
        ctx.arc(cx, cy, baseRadius, 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.closePath();
    }

    /**
     * Draws the points on the graph
     * @param u The uRanger plot 
     * @param i The series index being plotted
     * @param i0 The starting data index of each series being plotted
     * @param i1 The ending data index of each series being plotted
     */
    function drawPoints(u: any, i: any, i0: any, i1: any) {
        let { ctx } = u;
        let { _stroke, scale } = u.series[i];

        ctx.save();

        ctx.fillStyle = _stroke;

        let j = i0;

        while (j <= i1) {
            let val = u.data[i][j];
            if (val !== null) {
                let epochStartTime = u.data[0][j];
                let epochStartPos = Math.round(u.valToPos(epochStartTime, 'x', true));
                let cx = epochStartPos;
                let cy = Math.round(u.valToPos(val, scale, true));
                drawCircle(ctx, cx, cy, 'orange');
            }
            j++;
        };

        ctx.restore();
    }

    return {
        opts: (u: any, opts: any) => {
            opts.series.forEach((s: any, i: any) => {
                if (i > 0) {
                    uPlot.assign(s, {
                        points: {
                            show: drawPoints,
                        }
                    });
                }
            });
        },
    };
}

export function formatAnnotationsPluginMarks(patientVisits: PatientVisit[]) {
    function formatSingleMark(visit: PatientVisit) {
        let color = "";
        let val = 0;
        if (visit.encounter_types?.includes("Emergency")) {
            color = "red"
            val = 5
        } else if (visit.encounter_types?.includes("Hospital Encounter")) {
            color = "orange"
            val = 4
        } else if (visit.encounter_types?.includes("Outpatient")) {
            color = "green"
            val = 3
        } else if (visit.encounter_types?.includes("Ambulatory")) {
            color = "purple"
            val = 2
        } else if ((!visit.encounter_types?.includes("Emergency")) && (!visit.encounter_types?.includes("Hospital Encounter")) && (!visit.encounter_types?.includes("Outpatient")) && (!visit.encounter_types?.includes("Ambulatory"))) {
            color = "gray"
            val = 1
        }
        return {
            from: new Date(visit.arrival_time).getTime() / 1000,
            to: visit.departure_time ? new Date(visit.departure_time).getTime() / 1000 : new Date().getTime() / 1000,
            color: color,
            val: val,
        };
    }

    const marks: any[] = [];

    patientVisits.forEach(pt => {
        marks.push(formatSingleMark(pt));
    });
    return marks;
}

/**
 * The uPlot plugin to render horizontal lines on the plot
 * @param opts The uPlot options
 * @returns The uPlot plugin for annotations
 */
export function horizontalAnnotationsPlugin(xMarks: any) {
    function placeMark(u: any, mark: any) {
        let markEl = document.createElement('div');
        markEl.classList.add('u-mark-x');

        let topCss = Math.round(u.valToPos(mark.val, 'y'));
        let leftCss = Math.round(u.valToPos(mark.from, 'x'));
        let widthCss = mark.to > mark.from ? Math.round(u.valToPos(mark.to, 'x')) - leftCss : 0;

        Object.assign(markEl.style, {
            left: `${leftCss}px`,
            top: `${topCss - 2}px`,
            width: `${widthCss}px`,
            height: '4px',
            background: mark.color,
            opacity: '0.5'
        });

        u.over.appendChild(markEl);
    }

    return {
        hooks: {
            drawClear: [
                (u: any) => {
                    for (let el of u.over.querySelectorAll('.u-mark-x'))
                        el.remove();

                    xMarks.forEach((mark: any) => {
                        placeMark(u, mark);
                    });
                }
            ],
        },
    };
}

